import {EmbedType} from "./embed-type"
import {EMBED_DEFAULT_CONFIG} from "./configs/default"
import {EMBED_FACEBOOK_CONFIG} from "./configs/facebook"
import {EMBED_FIGMA_CONFIG} from "./configs/figma"
import {EMBED_GOOGLE_CALENDAR_CONFIG} from "./configs/google-calendar"
import {EMBED_GOOGLE_DOC_CONFIG} from "./configs/google-doc"
import {EMBED_GOOGLE_MAP_CONFIG} from "./configs/google-map"
import {EMBED_GOOGLE_SHEET_CONFIG} from "./configs/google-sheet"
import {EMBED_GOOGLE_SLIDES_CONFIG} from "./configs/google-slides"
import {EMBED_TWITTER_CONFIG} from "./configs/twitter"
import {EMBED_YOUTUBE_CONFIG} from "./configs/youtube"

export type EmbedTypeConfig = {
    name            : string
    icon            : string
    iconSvg?        : string
    description?    : string
    embedCode?      : any           // this is ...
    projectIcon?    : string

    keyWords?       : string[]

    embedCodeLabel? : string
    helpContent?    : any           // special help content below the form (HTML)
}

export const EmbedTypeConfigs : { [key in EmbedType]: EmbedTypeConfig } = {
    [EmbedType.DEFAULT]         : EMBED_DEFAULT_CONFIG,
    [EmbedType.YOUTUBE]         : EMBED_YOUTUBE_CONFIG,
    [EmbedType.FIGMA]           : EMBED_FIGMA_CONFIG,
    [EmbedType.GOOGLE_CALENDAR] : EMBED_GOOGLE_CALENDAR_CONFIG,
    [EmbedType.GOOGLE_DOC]      : EMBED_GOOGLE_DOC_CONFIG,
    [EmbedType.GOOGLE_SHEET]    : EMBED_GOOGLE_SHEET_CONFIG,
    [EmbedType.GOOGLE_SLIDES]   : EMBED_GOOGLE_SLIDES_CONFIG,
    [EmbedType.FACEBOOK]        : EMBED_FACEBOOK_CONFIG,
    [EmbedType.TWITTER]         : EMBED_TWITTER_CONFIG,
    [EmbedType.GOOGLE_MAP]      : EMBED_GOOGLE_MAP_CONFIG,
}